import api from './api';

export const itemService = {
  async list(itemType, params = {}) {
    const response = await api.get('/items/', { params: { item_type: itemType, ...params } });
    return response.data;
  },

  async create(payload) {
    const response = await api.post('/items/', payload);
    return response.data;
  },

  async update(id, payload) {
    const response = await api.put(`/items/${id}`, payload);
    return response.data;
  },

  async remove(id) {
    return this.update(id, { is_active: false });
  },

  async bulkDelete(itemIds) {
    await api.delete('/items/bulk', { data: { item_ids: itemIds } });
    return true;
  },
};
